import { z } from 'zod';

/**
 * AssetGroupSchema for form validation
 * Using i18n keys for error messages to support multi-language validation
 */
export const AssetGroupSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, { message: 'form.validation.assetGroupNameRequired' }),
    description: z.string().optional(),
    category: z.string().min(1, { message: 'form.validation.categoryRequired' }),
    categoryIndex: z.string().min(1, { message: 'form.validation.categoryIndexRequired' }),
    assetIds: z.array(z.string()).optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateAssetGroupSchema = AssetGroupSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateAssetGroupSchema = AssetGroupSchema.partial();

/** System default group when tenant has no BIGDES license (see seed: ensure-default-asset-group-without-bigdes). */
export const NO_BIGDES_DEFAULT_ASSET_GROUP_CODE = 'NO_BIGDES_DEFAULT';
